import { AnimatePresence, motion } from 'motion/react';

import type { ReviewQuestion } from '@/types/review/ReviewQuestion';
import type { ReactNode } from 'react';

interface AnimatedAnswerContainerProps {
    contentKey?: string | number;
    question: ReviewQuestion;
    enableTransitions?: boolean;
    transitionDurationMs: number;
    transitionDirection?: 'next' | 'previous';
    children: ReactNode;
}

export const AnimatedAnswerContainer = ({
    contentKey,
    question,
    enableTransitions,
    transitionDurationMs,
    transitionDirection,
    children,
}: AnimatedAnswerContainerProps) => {
    const initialX = enableTransitions && transitionDirection === 'previous' ? -100 : 100;

    const animationVariants = {
        initial: {
            opacity: 0,
            x: initialX,
        },
        animate: {
            opacity: 1,
            x: 0,
        },
        exit: {
            opacity: 0,
            x: transitionDirection === 'previous' ? 100 : -100,
        },
    };

    return (
        <AnimatePresence mode={'wait'}>
            <motion.div
                key={contentKey ?? question.id}
                initial={enableTransitions ? animationVariants.initial : undefined}
                animate={enableTransitions ? animationVariants.animate : undefined}
                exit={enableTransitions ? animationVariants.exit : undefined}
                transition={{
                    duration: transitionDurationMs / 1000,
                    ease: 'easeOut',
                }}
                className={
                    'z-10 flex w-full flex-1 items-center justify-center rounded-2xl bg-transparent'
                }
            >
                {children}
            </motion.div>
        </AnimatePresence>
    );
};
